import React from 'react';

// Components
import { Text, Box } from '@nerdwallet/currency';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';

import ElementImpressionInteraction from '../../../containers/element-impression-interaction';

import styles from './card-cta.module.less';

type CtaProps = {
  children?: React.ReactNode;
  subtitle?: string;
  title?: string;
  trackingId: string;
};

const Cta: React.FC<CtaProps> = ({
  children,
  subtitle = '',
  title = '',
  trackingId,
}) => {
  const impressionId = `mortgages-${trackingId}`;

  return (
    <Box className={styles.cta}>
      {title && (
        <Text size="large" bold>
          {title}
        </Text>
      )}
      {subtitle && (
        <Box className={styles.ctaSubtitle}>
          <Text>{subtitle}</Text>
        </Box>
      )}
      <Box className="ctaControls">
        <ElementImpression id={impressionId} elementName={trackingId}>
          {/* @ts-ignore - ignore 'prop children doesn't exist' error for ElementImpressionInteraction */}
          <ElementImpressionInteraction
            id={impressionId}
            elementName={trackingId}
            type="CLICK"
          >
            {children}
          </ElementImpressionInteraction>
        </ElementImpression>
      </Box>
    </Box>
  );
};

export default Cta;
